import { connect } from 'react-redux';
import { IStoreState } from 'src/entity/StateEntity';
import PharmacySetting from 'src/components/common/PharmacySetting';

const mapStateToProps = ({ userState: { userInfo, isAgent }, drugStoreState: { drugStores }, mallPharmacyState: { pharmacyList } }: IStoreState) => ({
  isAgent,
  userInfo,
  drugStoreList: drugStores,
  pharmacyList,
});

export default connect(mapStateToProps)(PharmacySetting);



// WEBPACK FOOTER //
// ./src/containers/PharmacySetting.ts